import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { ErrorHandlerProvider } from "../../../shared/providers/errorHandler.provider";
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { Responsible } from "../../../models/Responsible.model";
import { Component, OnInit } from "@angular/core";
import { LegalCertificateService } from "../../../services/legalCertificate.service";
import { LegalCertificate } from "../../../models/legalCertificate.model";
import * as moment from "moment";
import { AwsService } from "../../../services/aws.service";
import { UserService } from '../../../services/user.service';

@Component({
    selector: "app-legalCertificate-create",
    templateUrl: "./legalCertificate-create.component.html",
    styleUrls: ["./legalCertificate-create.component.scss"]
})
export class LegalCertificateCreateComponent implements OnInit {
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    maskDate = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    selectedFiles: FileList[] = [];
    legalCertificateForm: FormGroup;
    responsibles: Responsible[] = new Array<Responsible>();
    types: any;
    loading: boolean = false;
    certificates: LegalCertificate = new LegalCertificate();

    constructor(
        private formBuilder: FormBuilder,
        public  commonHelper: CommonHelper,
        private errorHandler: ErrorHandlerProvider,
        private awsService: AwsService,
        private legalCertificateService: LegalCertificateService,
        private toastr: ToastsManager,
        private router: Router,
        private userService: UserService
    ){};

    async ngOnInit(): Promise<void> {
        this.loading = true;

        this.legalCertificateForm = this.formBuilder.group({
            name: [null, Validators.required],
            renovationDate: [null, Validators.required],
            notificationsDays: [null, Validators.required],
            type: [null, [this.validateSelectOption]],
            owner: [null, [this.validateSelectOption]],
        });

        this.types = this.commonHelper.getAllCertificateType();
        this.responsibles = await this.userService.getAllUsersAsResponsibles();

        this.loading = false;
    };

    async Onsave() {
        try {
            this.certificates.owner.name = this.responsibles.find(x => x._id === this.certificates.owner._id).name;
            this.certificates.renovationDate = moment(this.certificates.renovationDate, 'DD/MM/YYYY').format("YYYY-MM-DD[T00:00:00]")

            let response = await this.legalCertificateService.create(this.certificates);
            if (response._id) {
                if(this.selectedFiles.length){
                    await this.upload(response._id);
                }
                this.toastr.success('Certidão / Procuração criado com sucesso!');
                this.router.navigate(['/legal-certificates']);
            } else {
                this.errorHandler.interceptError(response, 'Certidão/Procuração');
            }
        } catch (err) {
            this.errorHandler.interceptError(err, 'Certidão/Procuração');
        }
    }

    cancel() {
        this.router.navigate(['/legal-certificates']);
    }

    verifyValidTouched(fieldName) {
        return !this.legalCertificateForm.get(fieldName).valid && this.legalCertificateForm.get(fieldName).touched;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == undefined || control.value == 'undefined')
            return {type: true};
        return null;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    verifyDate(date){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.certificates.renovationDate = null;
        }
    }

    verifyNameMask(rawValue: string): RegExp[] {
        const mask = /[A-Za-zÁ-Úá-úÀ-Ùà-ùÃ-Õã-õÄ-Üä-üÂ-Ûâ-ûÇç' '0-9]/;
        const strLength = String(rawValue).length;
        const nameMask: RegExp[] = [];
        for (let i = 0; i <= strLength; i++) {
          nameMask.push(mask);
        }
        return nameMask
    }

    selectFile(event) {
        if(event.target.files.length > 0 && event.target.files[0].type != 'application/pdf') {
            return this.toastr.warning('O arquivo selecionado não possui extensão PDF');
        }
        this.selectedFiles.push(event.target.files)
    }

    async upload(id: string) {

        if(!this.selectedFiles.length) {
            return this.toastr.warning('Para fazer o upload é necessário selecionar arquivos');
        };

        try {
            for(let i=0; i<this.selectedFiles.length; i++){
                const file = this.selectedFiles[i].item(0);
                await this.awsService.uploadfile(
                    file,
                    `legal-certificates/${id}-${i}`,
                );
            }
        } catch (error) {
            console.log(error);
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/views/legalCertificate/legalCertificate-create/legalCertificate-create.component.ts